import { styled } from '@stitches/react';
import { useMemo } from 'react';
import { useElements, useScene } from '../../hooks';

export const TextElement = ({ elementID }: { elementID: string }) => {
  const scene = useScene();
  const [element] = useElements({ id: elementID });

  const Text = useMemo(
    () => styled('span', element?.props?.class as {}),
    [element?.props?.class]
  );

  return (
    <Text
      element-type="text"
      id={element?.id}
      {...scene.launcherStateProps}
      onDragStart={(e) => e.preventDefault()}
    >
      {element?.props?.text}
    </Text>
  );
};
